<template>
  <div class="main-content">
    <div class="page-header">
      <h2 class="header-title">Место / Школа</h2>
    </div>
    <!-- Content goes Here -->
    <div class="card">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" v-for="(item, index) in tabs" :key="index">
          <a
            class="nav-link"
            href="#"
            :class="{ active: index == tab_active }"
            @click.prevent="tab_active = index"
          >
            {{ item.name_ru }}
          </a>
        </li>
      </ul>
      <div class="card-body">
        <div class="tab_block" v-if="tab_active == 0">
          <Country />
        </div>
        <div class="tab_block" v-if="tab_active == 1">
          <Oblast />
        </div>
        <div class="tab_block" v-if="tab_active == 2">
          <Rayon />
        </div>
        <div class="tab_block" v-if="tab_active == 3">
          <School />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Country from "@/components/PlaceSchool/Country.vue";
import Oblast from "@/components/PlaceSchool/Oblast.vue";
import Rayon from "@/components/PlaceSchool/Rayon.vue";
import School from "@/components/PlaceSchool/School.vue";

export default {
  name: "PlaceSchool",
  components: {
    Country,
    Oblast,
    Rayon,
    School,
  },
  data() {
    return {
      tabs: [
        { name_ru: "Страна" },
        { name_ru: "Область" },
        { name_ru: "Район/Город" },
        { name_ru: "Школа" },
      ],
      tab_active: 0,
    };
  },
  methods: {},
  mounted() {
    this.$nextTick(function () {});
  },
};
</script>
<style lang="scss" scoped>
.card {
  overflow: hidden;
}
.nav-tabs > li > a {
  font-weight: 500;
}
.nav-tabs > li > a.active.nav-link {
  border-bottom: none;
  color: #fff;
  background-color: #886cff;
}
.nav-tabs {
  border-bottom: 1px solid #b6a6ff;
}
</style>
